import * as z from "zod";

export const getWorkOrderBomSkus = {
  name: "getWorkOrderBomSkus" as const,
  input: z.object({
    kind: z.enum(["input", "output"]),
    filterSearch: z.string().nullish(),
  }),
  output: z.object({ skus: z.array(z.string()) }),
};
